export default {
  SERVER_ENDPOINT: process.env.REACT_APP_SERVER_ENDPOINT,
  WS_SERVER_ENDPOINT: process.env.REACT_APP_WS_SERVER_ENDPOINT,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  ReCAPTCHA_KEY: process.env.REACT_APP_ReCAPTCHA_KEY,
  PUBLIC_URL: process.env.PUBLIC_URL,
  URL: process.env.REACT_APP_URL,
  DOMAIN: process.env.REACT_APP_DOMAIN,
  IS_DEMO: process.env.REACT_APP_IS_DEMO,
  IS_PROD: process.env.REACT_APP_IS_PROD,
  MAPBOX_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
  SENTRY_DSN_URL: process.env.REACT_APP_SENTRY_DSN_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
  CONTENTSQUARE_TAG_ID: process.env.REACT_APP_CONTENTSQUARE_TAG_ID,
  ONLYOFFICE_URL: process.env.REACT_APP_ONLYOFFICE_URL,
  SHOW_REACT_QUERY_DEVTOOL: process.env.REACT_APP_SHOW_REACT_QUERY_DEVTOOL,
  SHOW_DR_MAXIMUM_SECURITY: process.env.REACT_APP_SHOW_DR_MAXIMUM_SECURITY,
};
